<template>
  <div class="datetime_field_container">
    <mt-cell :title="label" is-link :value="value" @click.native="showBirthdayPicker"/>

    <mt-datetime-picker
      ref="picker"
      type="date"
      v-model="date"
      :closeOnClickModal="false"
      :startDate="startDate"
      @confirm="changeBirthday"
      @cancel="cancel"/>
  </div>
</template>

<script>
import { completeNum } from '@/utils/index'
import modalHelper from '@/utils/scroll'

export default {
  name: 'datetime-field',
  model: {
    prop: 'value',
    event: 'confirm'
  },
  props: ['value', 'label'],
  watch: {
    value () {
      this.date = this.value || '2000-01-01'
    }
  },
  data () {
    return {
      startDate: new Date(1920, 0, 1),
      date: ''
    }
  },
  created () {
    this.date = this.value || '2000-01-01'
    console.log(modalHelper)
  },
  methods: {
    showBirthdayPicker () {
      this.$refs.picker.open()
      modalHelper.afterOpen()
    },
    changeBirthday (value) {
      let year = value.getFullYear()
      let month = value.getMonth() + 1
      let day = value.getDate()
      month = completeNum(month, 2)
      day = completeNum(day, 2)
      let date = year + '-' + month + '-' + day

      modalHelper.beforeClose()
      this.$emit('confirm', date)
    },
    cancel () {
      modalHelper.beforeClose()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
